<template>
    		<!-- Restaurant Section -->
		<section class="restaurant-section restaurant-section-seven">
			<div class="container">
				<div class="section-heading-two section-heading-seven text-center">
					<div class="row">
						<div class="col-md-12 aos aos-init aos-animate" data-aos="fade-up">
							<img src="@/assets/img/heading-logo-small.png" class="img-fluid" alt="title-img">
							<h2>Popular Restaurant</h2>
							<p>What are you interested near you.</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-3 col-md-4 col-sm-6">
						<div class="dishes-box aos" data-aos="fade-up">
							<div class="dishes-img">
								<a href="#">
									<img src="@/assets/img/latest/Restaurant-1.jpg" class="img-fluid" alt="img">
								</a>
								<div class="feature-content justify-content-end">
									<span class="featured-text">Featured</span>
								</div>
								<div class="fav-item  justify-content-end">
									<a href="javascript:void(0)" class="fav-icon">
										<i class="fa-regular fa-bookmark"></i>
									</a>
								</div>
							</div>
							<div class="dishes-content">
								<div class="dishes-inner">
									<div class="author-img-new">
										<div class="inner-img">
											<img src="@/assets/img/profiles/avatar-06.jpg" class="img-fluid" alt="img">
										</div>
									</div>
									<p class="title">USA</p>
									<h5><a href="javascript:void(0);"> Fine dining <i
												class="fa-solid fa-circle-check"></i></a></h5>
									<div class="dishes-review">
										<h6><i class="fa-regular fa-clock"></i>Open</h6>
										<h6 class="review-color">4.0<i class="fa-solid fa-star review-color"></i>
											<span class="img-fluid">8.5(Reviews)</span>
										</h6>
									</div>
								</div>
								<div class="dishes-footer">
									<div class="landmark">
										<h5> <i class="feather-map-pin"></i>
											Europe
										</h5>
									</div>
									<div class="amount">
										<h5>$400
											<span>/ hour</span>
										</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<div class="dishes-box aos" data-aos="fade-up">
							<div class="dishes-img">
								<a href="#">
									<img src="@/assets/img/latest/Restaurant-2.jpg" class="img-fluid" alt="img">
								</a>
								<div class="feature-content justify-content-end">
									<span class="featured-text">Featured</span>
								</div>
								<div class="fav-item  justify-content-end">
									<a href="javascript:void(0)" class="fav-icon">
										<i class="fa-regular fa-bookmark"></i>
									</a>
								</div>
							</div>
							<div class="dishes-content">
								<div class="dishes-inner">
									<div class="author-img-new">
										<div class="inner-img">
											<img src="@/assets/img/profiles/avatar-07.jpg" class="img-fluid" alt="img">
										</div>
									</div>
									<p class="title">Europe</p>
									<h5> <a href="javascript:void(0);"> Casual dining <i
												class="fa-solid fa-circle-check"></i></a></h5>
									<div class="dishes-review">
										<h6><i class="fa-regular fa-clock"></i>Open</h6>
										<h6 class="review-color">4.5<i class="fa-solid fa-star review-color"></i>
											<span class="img-fluid">10(Reviews)</span>
										</h6>
									</div>
								</div>
								<div class="dishes-footer">
									<div class="landmark">
										<h5> <i class="feather-map-pin"></i>
											United States
										</h5>
									</div>
									<div class="amount">
										<h5>$300
											<span>/ hour</span>
										</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<div class="dishes-box aos" data-aos="fade-up">
							<div class="dishes-img">
								<a href="#">
									<img src="@/assets/img/latest/Restaurant-3.jpg" class="img-fluid" alt="img">
								</a>
								<div class="feature-content justify-content-end">
									<span class="featured-text">Featured</span>
								</div>
								<div class="fav-item  justify-content-end">
									<a href="javascript:void(0)" class="fav-icon">
										<i class="fa-regular fa-bookmark"></i>
									</a>
								</div>
							</div>
							<div class="dishes-content">
								<div class="dishes-inner">
									<div class="author-img-new">
										<div class="inner-img">
											<img src="@/assets/img/profiles/avatar-08.jpg" class="img-fluid" alt="img">
										</div>
									</div>
									<p class="title">China</p>
									<h5><a href="javascript:void(0);"> Family-style dining <i
												class="fa-solid fa-circle-check"></i></a></h5>
									<div class="dishes-review">
										<h6><i class="fa-regular fa-clock"></i>Open</h6>
										<h6 class="review-color">3.0<i class="fa-solid fa-star review-color"></i> <span
												class="img-fluid">7.0(Reviews)</span></h6>
									</div>
								</div>
								<div class="dishes-footer">
									<div class="landmark">
										<h5> <i class="feather-map-pin"></i>
											China
										</h5>
									</div>
									<div class="amount">
										<h5>$250
											<span>/ hour</span>
										</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<div class="dishes-box aos" data-aos="fade-up">
							<div class="dishes-img">
								<a href="#">
									<img src="@/assets/img/latest/Restaurant-4.jpg" class="img-fluid" alt="img">
								</a>
								<div class="feature-content justify-content-end">
									<span class="featured-text">Featured</span>
								</div>
								<div class="fav-item  justify-content-end">
									<a href="javascript:void(0)" class="fav-icon">
										<i class="fa-regular fa-bookmark"></i>
									</a>
								</div>
							</div>
							<div class="dishes-content">
								<div class="dishes-inner">
									<div class="author-img-new">
										<div class="inner-img">
											<img src="@/assets/img/profiles/avatar-02.jpg" class="img-fluid" alt="img">
										</div>
									</div>
									<p class="title">England</p>
									<h5><a href="javascript:void(0)"> Fast-casual dining <i
												class="fa-solid fa-circle-check"></i></a></h5>
									<div class="dishes-review">
										<h6><i class="fa-regular fa-clock"></i>Open</h6>
										<h6 class="review-color">2.5<i class="fa-solid fa-star review-color"></i> <span
												class="img-fluid">5.0(Reviews)</span></h6>
									</div>
								</div>
								<div class="dishes-footer">
									<div class="landmark">
										<h5> <i class="feather-map-pin"></i>
											Denmark
										</h5>
									</div>
									<div class="amount">
										<h5>$300
											<span>/ hour</span>
										</h5>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /Restaurant Section -->

		<!-- Cities Section -->
		<section class="cities-section">
			<div class="container">
				<div class="cities-sec">
					<div class="row">
						<div class="col-md-8">
							<div class="section-heading section-heading-seven d-flex align-items-center aos"
								data-aos="fade-up">
								<div class="heading-img">
									<img src="@/assets/img/heading-logo.png" class="img-fluid m-0" alt="img">
								</div>
								<div>
									<h2>Featured Cities </h2>
									<p>Explore restaurants & cafes by locality</p>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-4 col-md-6 col-sm-6 aos" data-aos="fade-up">
							<div class="cities-box">
								<div class="cities-img">
									<img src="@/assets/img/city/cities-1.jpg" class="img-fluid" alt="img">
								</div>
								<div class="cities-overlay-item">
									<div class="cities-overlay">
										<div class="rating">
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
										</div>
										<h5>New York</h5>
										<div class="cities-location">
											<p><i class="feather-map-pin"></i>12 Cities </p>
											<p> <i class="fa-solid fa-map"></i>30+ Listing</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-4 col-md-6 col-sm-6 aos" data-aos="fade-up">
							<div class="cities-box">
								<div class="cities-img ">
									<img src="@/assets/img/city/cities-2.jpg" class="img-fluid" alt="img">
								</div>
								<div class="cities-overlay-item">
									<div class="cities-overlay">
										<div class="rating">
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-regular fa-star"></i>
											<i class="fa-regular fa-star"></i>
										</div>
										<h5>Sydney</h5>
										<div class="cities-location">
											<p><i class="feather-map-pin"></i>10 Cities </p>
											<p> <i class="fa-solid fa-map"></i>50+ Listing</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-4 col-md-6 col-sm-6 aos" data-aos="fade-up">
							<div class="cities-box">
								<div class="cities-img">
									<img src="@/assets/img/city/cities-3.jpg" class="img-fluid" alt="img">
								</div>
								<div class="cities-overlay-item">
									<div class="cities-overlay">
										<div class="rating">
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-regular fa-star"></i>
											<i class="fa-regular fa-star"></i>
											<i class="fa-regular fa-star"></i>
										</div>
										<h5>London</h5>
										<div class="cities-location">
											<p><i class="feather-map-pin"></i>18 Cities </p>
											<p> <i class="fa-solid fa-map"></i>15+ Listing</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class=" col-lg-3 col-md-6 col-sm-6 aos" data-aos="fade-up">
							<div class="cities-box cities-spl-box">
								<div class="cities-img cities-height">
									<img src="@/assets/img/city/cities-4.jpg" class="img-fluid" alt="img">
								</div>
								<div class="cities-overlay-item">
									<div class="cities-overlay">
										<div class="rating">
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-regular fa-star"></i>
											<i class="fa-regular fa-star"></i>
										</div>
										<h5>New York</h5>
										<div class="cities-location">
											<p><i class="feather-map-pin"></i>8 Cities </p>
											<p> <i class="fa-solid fa-map"></i>22+ Listing</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-6 aos" data-aos="fade-up">
							<div class="cities-box">
								<div class="cities-img loca-height">
									<img src="@/assets/img/city/cities-5.jpg" class="img-fluid" alt="img">
								</div>
								<div class="cities-overlay-item">
									<div class="cities-overlay">
										<div class="rating">
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-regular fa-star"></i>
										</div>
										<h5>Miami</h5>
										<div class="cities-location">
											<p><i class="feather-map-pin"></i>15 Cities </p>
											<p> <i class="fa-solid fa-map"></i>35+ Listing</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 aos" data-aos="fade-up">
							<div class="cities-box">
								<div class="cities-img">
									<img src="@/assets/img/city/cities-6.jpg" class="img-fluid" alt="img">
								</div>
								<div class="cities-overlay-item">
									<div class="cities-overlay">
										<div class="rating">
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-solid fa-star"></i>
											<i class="fa-regular fa-star"></i>
										</div>
										<h5>London</h5>
										<div class="cities-location">
											<p><i class="feather-map-pin"></i>10 Cities </p>
											<p> <i class="fa-solid fa-map"></i>20+ Listing</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /Cities Section  end-->
    </template>